import { FilterOutlined, PlusOutlined } from "@ant-design/icons";
import { Card, Flex, Row, Space, Button } from "antd";
import { useEffect, useState } from "react";

import { CardContainer } from "components/elements";
import WelfareTable from "components/table/WelfareTable";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styles from "../styles/Welfare.module.css";
import PayRollWelfareFilter from "./PayrollWelfareFilter";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";

const PayrollWelfare = ({
  isLoading = false,
  pagination = {},
  welfareList = [],
  welfareOption = [],
  welfareTypeOptions = [],
  welfareSubTypeOptions = [],
  onCreate = () => { },
  onEdit = () => { },
  onDelete = () => { },
  onStatus = () => { },
  handleMenuChange = () => { },
  onChange = () => { },
  onSubmit = () => { },
  onCancel = () => { },
  onSearch = () => { },
}) => {
  const { t } = useTranslation();
  const [useFilter, setUseFilter] = useState(false);
  const { roles } = useSelector((state) => state.company);

  return (

    <Space className={styles.container} size={24} direction="vertical">
      <Row justify="end">
        <Space direction="horizontal" size={10}>
          <Button type="default" onClick={() => setUseFilter(!useFilter)} style={{ padding: "8px 16px", height: "44px", borderRadius: "8px" }}>
            <Flex align="center" justify="center" gap={8}>
              <FilterIcon />
              <span style={{ color: "#667085" }}>{t('common.filter')}</span>
            </Flex>
          </Button>
          {
            roles.includes("CREATE_CONFIGURATION|PAYROLL_SETTING|WELFARE") && <Button onClick={onCreate} style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "10px 16px" }}
              type="primary">
              <Flex align="center" justify="center" gap={8}>
                <CreateIcon />
                {t("common.create")}
              </Flex>
            </Button>
          }

        </Space>
      </Row>
      {/* <Row span={24}> */}
      {/* <Col span={5}>
          <PayrollWelfareMenu onChange={handleMenuChange} />

        </Col> */}
      {/* <Col span={19}> */}
      <Flex gap={20} vertical={true}>
        {useFilter && (
          <Card width="100%" style={{ border: "1px solid #EAECF0", borderRadius: "8px" }} >
            <PayRollWelfareFilter
              welfareOption={welfareOption}
              welfareTypeOptions={welfareTypeOptions}
              onChange={onChange}
              onSubmit={onSearch}
              onCancel={onCancel}
              isLoading={isLoading}
              welfareSubTypeOptions={welfareSubTypeOptions}
            />
          </Card>
        )}
        {/* <CardContainer width="100%" height="fit-content" > */}
        <WelfareTable
          isLoading={isLoading}
          pagination={pagination}
          dataSource={welfareList}
          onEdit={onEdit}
          onDelete={onDelete}
          onStatus={onStatus}
          onChange={onChange}
        />
        {/* </CardContainer> */}
      </Flex>
      {/* </Col> */}

      {/* </Row> */}
    </Space>

  );
};

export default PayrollWelfare;
